import './Overlay.css';

export const Overlay = () => {
    return <div className={"overlay"}/>
}